import { Product } from "../models/Product";

export const professionalProducts: Record<string, Product> = {
  professional_marketplace: {
    id: "price_1RMcHJGaV74rHEMxzoASseHm",
    title: "Professional Marketplace",
    description: "Connect with clients and other professionals.",
    price: 299,
    type: "feature",
    unlocks: [],
    upsellProducts: [],
  },
};

export type ProfessionalProductType = keyof typeof professionalProducts;
